import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RegisterService } from './register.service';
import { NotificationService } from '../_helpers/notification.service';
import { Router } from '@angular/router';
import { AppSettings } from '../_helpers/app.settings';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {
  form: any = {
    username: null,
    email: null,
    password: null,
    confirmpassword: null,
    token: null
  };
  termCond1: boolean = false;
  termCond2: boolean = false;
  
  isSavePending: boolean = false;
  
  constructor(
    private registerService: RegisterService,
    private notification: NotificationService,
    private router: Router
  ) {

  }
  register(registerForm: NgForm) {
    this.isSavePending = true;
    let isValid = this.validateFormFields(registerForm.value);
   
    if(!isValid) {
      this.isSavePending = false;
      return;
    }
    let data = {
      email: registerForm.value.email,
      username: registerForm.value.username,
      password: btoa(registerForm.value.password), 

    };
    this.registerService.register({
      data: data,
      skipToken: true,
      success: (response: any) => {
        if(response?.message) {
          this.notification.showSuccess(response.message);
          this.router.navigate([AppSettings.LOGIN_ROUTE]);
        }
        this.isSavePending = false;
      },
      error: (error: any) => {
        this.notification.showError(error.errorMessage);
        this.isSavePending = false;
      }
    });

  }
  validateFormFields(formVal: any) {
    if(!this.isValidEmail(formVal.email)) {
      return false;
    }
    if(!this.isValidUserName(formVal.username)) {
      return false;
    }
    if(!this.isValidPassword(formVal.password, formVal.confirmpassword)) {
      return false;
    }
    return true;
  }
  isValidEmail(email: string) {
    let regEx = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;
    if(!regEx.test(email)) {
      this.showValidationError('email');
      return false;
    }
    return true;
  }
  isValidUserName(userName: string) {
    let regEx = /(^[a-z])+([a-z0-9_])+([a-z0-9_]{4,}$)/i;
    if (userName.length > 50) {
      this.showValidationError('userName');
      return false;
    }
    if(!regEx.test(userName)) {
      this.showValidationError('userName');
      return false;
    }
    return true;
  }
  isValidName(userName: string) {
    let regEx = /^[a-z A-Z]+$/;
    if (userName.length < 3 || userName.length > 50) {
      this.showValidationError('name');
      return false;
    }
    if (!regEx.test(userName)) {
      this.showValidationError('name');
      return false;
    }
    return true;
  }
  isValidPassword(password: string, confirmpassword: string) {
    var PWD_REGEX = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%_\-*&(){}?]).{8,16})/i;
    var matchRegEx = PWD_REGEX.test(password);
    if (password.length < 8 || password.length > 16) {
      this.showValidationError('password_length');
      return false;
    }
    if(matchRegEx == false) {
      this.showValidationError('password_regex');
      return false;
    }
    if(password != confirmpassword) {
      this.showValidationError('password');
      return false;
    }
    return true;
  }
  showValidationError(field: string) {
    if(!field) {
      return;
    }
    let msg = '';
    switch(field) {
      case 'email':
        msg = 'Please enter valid Email.';
        break;
      case 'userName':
        msg = 'Please enter valid User Name. Min length should be 6, Max length should be 50. First letter should be an alphabet and Special characters/spaces are not allowed.'
        break;
      case 'password':
        msg = 'Both Password and Confirm Password should match.'
        break;
      case 'userType':
        msg = 'Please verify manager username.';
        break;
      case 'name':
        msg = 'Please verify Name. Min length should be 3, Max length should be 50. First letter should be an alphabet and Special characters/spaces are not allowed.';
        break;
      case 'password_length':
        msg = 'Password should contain 8-16 characters';
        break;
      case 'password_regex':
        msg = 'Password must contain Alphanumeric and special characters.';
        break;
    }
    this.notification.showError(msg);
  }
}
